export const wait = (ms: number = 10) => new Promise(r => setTimeout(r, ms));
